class CarouselLoad {
  constructor(carouselId, config, mobileScrollable, useLoader) {
    this.carouselId = carouselId;
    this.$carousel = document.querySelector(this.carouselId);
    this.mobileScrollable = mobileScrollable;
    this.$carousel.classList.add("io");
    this.path = this.$carousel.dataset.contentUrl;
    this.listName = this.$carousel.dataset.listName;
    this.config = config;
    this.options = { root: this.$carousel };
    // Load using observer
    if (useLoader) {
      this.initObserver();
    }

    if (mobileScrollable) {
      // Register breakpoints events for transform slider to scrollable
      enquire.register(Domestika.enquire.tablet_down, { match: this.disable });
      enquire.register(Domestika.enquire.tablet_up, { match: this.enable });
    } else {
      this.enable();
    }
  }

  disable = () => {
    this.carousel = null;
    this.grid(true);
    this.scrollable(true);
  };

  enable = async () => {
    if (!this.swiper) {
      const imgRes = await import("swiper/bundle");
      if (imgRes) {
        this.swiper = imgRes.default;
      }
    }

    // eslint-disable-next-line new-cap
    this.carousel = new this.swiper(this.carouselId, this.config);
    if (this.mobileScrollable) {
      this.carousel.on("init", this.grid(), this.scrollable());
    }
    this.carousel.init();

    this.initSwiperListeners();
  };

  initSwiperListeners = () => {
    // Listener on slide change
    this.carousel.on("slideChange", (data) => {
      data.slides
        .slice(
          data.activeIndex,
          data.activeIndex + (data.loopedSlides || data.visibleSlidesIndexes?.length)
        )
        .forEach((element) => {
          if (!element.classList.contains("loaded")) {
            this.activeElement({
              itemId: element.dataset.itemId,
              classList: element.classList,
              target: element,
            });
          }
        });
    });

    // Enable hover listener to all elements in carousel
    this.handleHoverListeners();

    // Destroy listener
    this.carousel.on("destroy", () => {
      this.handleHoverListeners(true);
    });
  };

  initObserver = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((el) => {
        if (
          el.isIntersecting &&
          !el.target.classList.contains("loaded") &&
          this.$carousel.classList.contains("scrollable")
        ) {
          this.activeElement({
            itemId: el.target.dataset.itemId,
            classList: el.target.classList,
            observer,
            target: el.target,
          });
        }
      });
    }, this.options);

    const notLoaded = this.$carousel.querySelectorAll(".swiper-slide:not(.loaded)");
    notLoaded.forEach((item) => {
      observer.observe(item);
    });
  };

  // Active element function
  activeElement = ({ itemId, classList, observer, target }) => {
    this.loadItem({ itemIds: itemId, carouselId: this.carouselId, listName: this.listName }, target);
    classList.add("loaded");
    if (observer) {
      observer.unobserve(target);
    }
  };

  // Add hover listeners
  handleHoverListeners = (remove) => {
    this.carousel.slides.forEach((target) => {
      target[remove ? "removeEventListener" : "addEventListener"]("mouseover", () => {
        target?.classList?.add("show");
      });
      target[remove ? "removeEventListener" : "addEventListener"]("mouseout", () => {
        target?.classList?.remove("show");
      });
    });
  };

  // Add/remove scrollable classes
  scrollable = (active = false) => {
    this.$carousel.classList.toggle("scrollable", active);
    this.$carousel.querySelector(".swiper-wrapper").classList.toggle("scrollable__child", active);
  };

  // Add/remove grid classes (bootstrap)
  grid = (active = false) => {
    this.$carousel.querySelector(".swiper-wrapper").classList.toggle("row", active);
    this.$carousel.querySelectorAll(".swiper-slide").forEach((el) => {
      el.classList.toggle("row-column", active);
    });
  };

  loadItem = (params, target) => {
    // eslint-disable-next-line no-undef
    $.get(this.path, params, () => {
      target.classList.remove("placeholder");
    });
  };
}

export { CarouselLoad };
